import { AreaGateReference } from './../../../../gate-keeping.model';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-gate-keeper-control-select-gate-tile',
  templateUrl: './gkc-select-gate-tile.component.html',
  styleUrls: ['./gkc-select-gate-tile.component.scss']
})
export class GKCSelectGateTileComponent {

  @Input() areaGate: AreaGateReference;
}
